if ( window.innerWidth > 991) {
    document.addEventListener("DOMContentLoaded", function(){
        const tl = gsap.timeline()
            .to('.dot-step', {
            background: '#29425c',
            ease: "none",
            duration: 1,
            opacity: 1,
            stagger: 1.15
        }, 0)
        .to('.items-container', {
            css:{
                className: 'row align-items-center items-container active'
            },
            opacity: 1,
            ease: "linear",
            duration: 1,
            stagger: 1.96
        }, 0)
        .to('.feature-item .diffternt-text', {
            ease: "linear",
            duration: 1,
            stagger: 1.5
        }, 0)
            .from('.bg-bar', {
            height: 0,
            ease: "linear",
            duration: 1,
            stagger: 1
        }, 1)
    
        const controller = new ScrollMagic.Controller();
        const scene = new ScrollMagic.Scene({
            triggerElement: '.items-container',
            triggerHook: .5,
            offset: 0,
            duration: "925"
        })
        .setTween(tl)
        .addTo(controller)
    });
}